// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 550,
      paddingBottom: 15,
    },
    subtitle: {
      margin: 0,
      marginLeft: 5,
      fontSize: '1.1em',
    },
    list: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(1),
        width: '100%',
      },
    },
    alert: {
      width: '100%',
    },
  }),
);

export default useStyles;
